<template>
  <v-card flat class="r5">
    <v-container grid-list-md fluid :class="classProp">
      <v-layout row wrap justify-space-between>
        <div
          class="di-flex align-center flex xs12 font-weight-bold px-3 py-2 text-xs-left mb-3"
        >
          <span> {{ $t("cash_payment_form") }} :</span>
          <v-divider class="ml-2" />
        </div>
        <v-flex xs12 :md6="!edit" class="pt-4">
          <v-layout row wrap class="px-3">
            <!-- <v-divider class="flex xs12 my-3"></v-divider> -->
            <async-autocomplete
              outline
              autofocus
              item-value="id"
              persistent-hint
              @setItem="setCustomer"
              url="/credits/create"
              item-text="full_name"
              queries="credits=true"
              :label="$t('customer')"
              v-validate="'required'"
              @change="setDescription"
              :edit-append="editAppend"
              :data-vv-name="'customer'"
              v-model="value.customer_id"
              :data-vv-as="$t('customer')"
              placeholder="Customer Name"
              class="flex xs12 right-hint"
              :error-messages="errors.collect('customer')"
              :hint="
                customerBalance | currency({ symbol: smbl(value.currency_id) })
              "
            >
              <template v-slot:item="data">
                <template>
                  <v-list-tile-avatar>
                    <img :src="data.item.image" />
                  </v-list-tile-avatar>
                  <v-list-tile-content>
                    <v-list-tile-title>{{
                      data.item.full_name
                    }}</v-list-tile-title>
                    <v-list-tile-sub-title>{{
                      $t(data.item.type)
                    }}</v-list-tile-sub-title>
                  </v-list-tile-content>
                </template>
              </template>
            </async-autocomplete>
            <v-date
              type="date"
              :clearable="false"
              format="YYYY-MM-DD"
              v-model="value.date"
              input_id="debit_date"
              value-type="YYYY-MM-DD"
              :placeholder="$t('date')"
              class="flex xs12 sm6"
              @input="$emit('date-changed')"
              :disabled-date="disableBackDate"
            />
            <v-date
              type="time"
              label="time"
              format="HH:mm:ss"
              :clearable="false"
              v-model="value.time"
              value-type="HH:mm:ss"
              input_id="debit_time"
              :placeholder="$t('time')"
              class="flex xs12 sm6"
              :disabled-time="disableBackDate"
            />
            <v-autocomplete
              outline
              item-value="id"
              persistent-hint
              item-text="name"
              placeholder="Cash/Bank"
              :items="branchAccounts"
              v-validate="'required'"
              @change="setDescription"
              :label="$t('payment_type')"
              v-model="value.receiver_id"
              :data-vv-name="'payment_type'"
              class="flex xs12 sm6 right-hint"
              :data-vv-as="$t('payment_type')"
              :error-messages="errors.collect('payment_type')"
              :hint="
                accountBalance | currency({ symbol: smbl(value.currency_id) })
              "
            />

            <v-autocomplete
              outline
              item-value="id"
              item-text="name"
              placeholder="USD"
              :items="currencies"
              class="flex xs12 sm6"
              :label="$t('currency')"
              v-validate="'required'"
              @change="setDescription"
              :data-vv-name="'currency'"
              v-model="value.currency_id"
              :data-vv-as="$t('currency')"
              :error-messages="errors.collect('currency')"
            />
            <v-text-field
              outline
              placeholder=" "
              persistentHint
              :label="$t('amount')"
              v-model="value.amount"
              :data-vv-name="'amount'"
              v-validate="'required'"
              :data-vv-as="$t('amount')"
              @change="setDescription"
              class="flex xs12 mb-3 capitalize"
              :hint="value.amount | toWord"
              v-currency="{ currency: null }"
              :error-messages="errors.collect('amount')"
            />
            <!-- <v-combobox
              outline
              placeholder=" "
              :label="$t('risk_profile')"
              v-model="value.risk_category"
              :items="['Low', 'Medium', 'High']"
              class="flex xs12 sm6 mb-3 capitalize"
            /> -->
            <v-textarea
              outline
              rows="0"
              auto-grow
              placeholder="Notes"
              class="flex xs12 py-0"
              :label="$t('description')"
              v-model="value.description"
            />
          </v-layout>
          <v-flex xs12 mt-2>
            <v-btn dark raised @click="save" color="primary" :loading="loading">
              {{ $t("save") }}
            </v-btn>
            <v-btn
              dark
              outline
              class="mx-0"
              color="primary"
              :loading="loading"
              @click="save(false)"
              :title="$t('save_print')"
            >
              <v-icon class="mx-2">print</v-icon>
            </v-btn>
            <v-btn
              dark
              raised
              outline
              v-if="!edit"
              @click="reset"
              color="primary"
              :loading="loading"
              :title="$t('new_record')"
            >
              <v-icon class="mx-1">mdi-refresh</v-icon>
            </v-btn>
          </v-flex>
        </v-flex>
        <v-flex xs12 :md4="!edit" class="mt-3 hidden-sm-and-down">
          <v-layout row wrap class="justify-center mb-3">
            <v-flex xs12 class="di-flex align-center justify-space-between">
              <div class="caption">
                <strong>{{ $t("files") }}</strong>
                <br />
                {{ $t("file_max_notation") }}
              </div>
              <file-chooser text color="secondary" v-model="value.files" />
            </v-flex>
            <v-flex
              xs12
              class="mt-3"
              v-if="value.files && value.files.length > 0"
            >
              <file-viewer :files="value.files" />
            </v-flex>
          </v-layout>
          <customer-tile :customer="customer" v-if="!edit" />
        </v-flex>
        <v-flex xs12 md6 v-show="false" class="px-4 hidden-xs-only">
          <debit-bill
            ref="bill"
            v-bind="{ debit: { ...value }, customer, system }"
          />
        </v-flex>
      </v-layout>
    </v-container>
  </v-card>
</template>

<script>
import { customersMixin, printBill } from "@/mixins/index.js";
import curjs from "currency.js";

export default {
  name: "debitForm",
  mixins: [customersMixin, printBill],
  props: {
    edit: { default: false },
    classProp: { default: "" },
    value: {
      default: () => ({
        id: null,
        amount: 0,
        description: "",
        customer_id: null,
        date: new Date(),
      }),
    },
  },

  data: () => ({
    loading: false,
    customer: {
      accounts: [],
    },
  }),

  computed: {
    editAppend() {
      if (this.value.id) return this.value.customer;
      return false;
    },

    receiver: (vm) =>
      vm.initialData.customers.find((x) => x.id == vm.value.receiver_id) || {
        accounts: [],
      },
    accountBalance: (vm) =>
      (
        vm.receiver.accounts.find(
          (x) => x.currency_id == vm.value.currency_id
        ) || {
          balance: 0,
        }
      ).balance,

    customerBalance: (vm) =>
      (
        vm.customer.accounts.find(
          (x) => x.currency_id == vm.value.currency_id
        ) || {
          balance: 0,
        }
      ).balance,

    system() {
      let system = this.initialData.customers.find((x) => x.type == "system");
      return system ? system : {};
    },

    currencies: (vm) => vm.initialData.currencies,

    branchAccounts: (vm) =>
      vm.initialData.customers.filter(
        (x) =>
          (x.type == "system" || x.type == "bank") &&
          x.id != vm.value.customer_id
      ),
  },

  methods: {
    setCustomer(item) {
      this.customer = item;
      this.setDescription();
    },
    setDescription() {
      if (!this.generate_description) return;
      this.value.description = `${this.$t("debit_description")} ${
        this.customer.name
      } ${this.$t("from")} ${this.receiver.name}`;
    },
    reset() {
      this.customer = {
        type: "external",
        accounts: [],
        details: {},
      };
      this.$emit("reset");
      this.loading = false;
      this.$validator.reset();
    },

    initData() {
      this.reset();
    },

    async save(disablePrint = true) {
      this.loading = true;
      this.$validator.validateAll().then((succeed) => {
        if (succeed) {
          this.value.amount = curjs(this.value.amount).value;
          if (this.accountBalance - this.value.amount < 0) {
            this.$confirm(
              this.$t("low_credit_alert"),
              this.$t("confirm_low_balance")
            )
              .then(() => {
                this.submitToDB(disablePrint);
              })
              .catch(() => {
                this.loading = false;
              });
          } else {
            this.submitToDB(disablePrint);
          }
        } else {
          this.$store.commit("showSnackbar", {
            text: this.$t("wrong_input"),
            stateType: "error",
            show: true,
          });
          this.loading = false;
        }
      });
    },
    
    submitToDB(disablePrint = false) {
      this.value.number =
        this.value.number || (this.system && this.system.last_form_number++);
      this.axios
        .post("debits", this.value)
        .then(async (res) => {
          let fils = this.value.files.filter((x) => !x.id);
          if (fils.length > 0) {
            const fd = new FormData();
            fd.append("fileable_type", "Debit");
            fd.append("fileable_id", res.data.id);
            for (const file of fils) {
              fd.append("files[]", file);
            }
            await this.axios.post("files", fd, {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            });
          }

          this.value.id = res.data.id;
          this.value.time = res.data.time;
          this.value.date = res.data.date;
          this.value.receiver = res.data.receiver;
          await this.getCustomers();
          this.printBill(this.$refs.bill.$el, disablePrint);
          this.loading = false;
          this.$store.commit("showSnackbar", {
            text: this.$t("save_succeed"),
            stateType: "success",
            show: true,
          });
          this.$emit("saved", res.data);
          this.reset();
        })
        .catch((error) => {
          console.error(error);
          this.$store.commit("showSnackbar", {
            text: error.response.data.message,
            stateType: "error",
            show: true,
          });
          this.loading = false;
        });
    },
  },
};
</script>